"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var optimizely_sdk_1 = require("@optimizely/optimizely-sdk");
var browserHelper_1 = require("./browserHelper");
var cookieUtils_1 = require("./cookieUtils");
var optimizely_1 = require("./../constants/optimizely");
// tslint:disable-next-line:import-name
var uuidv4 = require("uuid/v4");
exports.LOG_LEVEL = optimizely_sdk_1.enums.LOG_LEVEL;
// As new A/B tests are added, expand this list, the OptimizelyTestName type options, and OPTIMIZELY_TEST_NAMES
var abTests = {
    TestDriveDeepLinkTest: '',
    LeadFormCta: '',
    LeadFormModalOnVDP: '',
    TimeSavingsTest: '',
    VDPSecondCTA: '',
    PersistentSendCTA: '',
    OnboardingVdpAtcMobile: '',
    SocialOAuthLeadFormAtcKbb: '',
    SocialOAuthLeadFormDDC: '',
    VDP_REDESIGN_CONTROLS_CLASSIFIED: '',
    VDP_REDESIGN_CONTROLS_DEALER: '',
    VDP_LEAD_CLASSIFIED_KBB_ATC: '',
    VDP_LEAD_DEALER_DDC_OPT_IN: '',
    PAYMENT_REDESIGN_RETEST_ATC_KBB: '',
    PAYMENT_REDESIGN_RETEST_DDC: '',
    DEBUG_ADOBE_1: '',
    DEBUG_ADOBE_2: '',
    DEBUG_ADOBE_3: '',
    SDP_PANEL_CTA_DEALER: '',
    SDP_PANEL_CTA_CLASSIFIED: '',
    SIDE_BY_SIDE_PRICING_DEALER: '',
    SIDE_BY_SIDE_PRICING_CLASSIFIED: '',
    TRADEIN_SINGLE_COLUMN_DDC: '',
    TRADEIN_SINGLE_COLUMN_ATC_KBB: '',
    SHOPPER_ONBOARDING_ON_VDP_DDC: '',
    SHOPPER_ONBOARDING_ON_VDP_CLASSIFIED: '',
    SDP_LANDING_INTERSTITIAL_DEALER: '',
    SDP_LANDING_INTERSTITIAL_CLASSIFIED: '',
    SDP_LANDING_INTERSTITIAL_TEXT_DEALER: '',
    SDP_LANDING_INTERSTITIAL_TEXT_CLASSIFIED: '',
    TRADE_IN_NEXT_STEPS_DEALER: '',
    TRADE_IN_NEXT_STEPS_CLASSIFIED: '',
    MONTHLY_PAYMENT_RANGE_DEALER: '',
    MONTHLY_PAYMENT_RANGE_CLASSIFIED: '',
    DEAL_SUMMARY_LEAD_FORM_DEALER: '',
    DEAL_SUMMARY_LEAD_FORM_CLASSIFIED: '',
    SDP_LANDING_RECOMMENDED_STEP_DEALER: '',
    SDP_LANDING_RECOMMENDED_STEP_CLASSIFIED: '',
    SDP_MOBILE_MODAL_DEALER: '',
    TRADEIN_LEADFORM_SINGLE_COLUMN_DDC: '',
    TRADEIN_LEADFORM_SINGLE_COLUMN_ATC_KBB: '',
    SP_VEHICLE_PROTECTION: '',
    SP_SELECT_INCENTIVES: ''
};
var whitelist = ['16729681121', '16741690107', '16733720473'];
var listVar = 'list3';
var controlledLogLevel = exports.LOG_LEVEL.DEBUG;
var optimizelyClientInstance = null;
var loggerInstance = null;
var cookiePrefix = 'DROptimizely';
var url = 'https://cdn.optimizely.com/datafiles/JbnYJjoqDpK8tRnzKNbuhK.json';
var _dealer = null;
/**
 * Load
 * @constructor
 * @param {object} dealer - Dealer object for current audience
 * @param {string} logLevel - level which we want logging to appear in the console
 *
 * logLevels available:
 * NOTSET: NOTSET
 * DEBUG: DEBUG
 * INFO: INFO
 * WARNING: WARNING
 * ERROR: ERROR - defualt
 * https://docs.developers.optimizely.com/full-stack/docs/configure-the-logger
 * */
function load(dealer, logLevel, isProd) {
    _dealer = dealer;
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.responseType = 'json';
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status !== 200) {
                    console.error('Optimizely failed to load.');
                    reject();
                    return;
                }
                // Initialize the Optimizely client after getting the datafile
                // Skip JSON schema validation for the datafile to improve performance since pulling datafile from CDN
                optimizelyClientInstance = exports.initClientInstance(xhr.response, logLevel, isProd);
                var userId = exports.getUserId();
                if (!_dealer.isTestDealer) {
                    exports.activateTests(userId);
                }
                exports.setOverrides();
                resolve(abTests);
            }
        };
        // Get Optimizely datafile
        xhr.open('GET', url, true);
        xhr.send('');
    });
}
exports.load = load;
exports.initClientInstance = function (xhrResponse, logLevel, isProd) {
    if (isProd === void 0) { isProd = false; }
    var anyLogLevel = (logLevel !== undefined && logLevel !== null);
    if (!anyLogLevel && isProd) {
        controlledLogLevel = exports.LOG_LEVEL.ERROR;
    }
    else if (anyLogLevel) {
        controlledLogLevel = logLevel;
    }
    var loggerConfig = { logLevel: controlledLogLevel };
    loggerInstance = optimizely_sdk_1.logging.createLogger(loggerConfig);
    return optimizely_sdk_1.createInstance({
        datafile: xhrResponse,
        skipJSONValidation: true,
        logger: loggerInstance
    });
};
exports.optimizelyLog = function (msg) {
    if (controlledLogLevel !== exports.LOG_LEVEL.ERROR) {
        console.log('OPTIMIZELY LOGGER :: ', msg);
    }
};
exports.setLogLevel = function (level) {
    if (level === void 0) { level = null; }
    // null will turn off logging
    loggerInstance.setLogger(level);
    return loggerInstance;
};
exports.getCurrentDealer = function () { return _dealer; };
exports.getOptimizelyWindowObj = function () {
    return window['optimizely'] = window['optimizely'] || {};
};
exports.getAdobeAnalyticsTrackingObj = function () {
    return window['s'] || {};
};
exports.getUserId = function () {
    // tslint:disable-next-line: prefer-template
    var userIdCookie = cookiePrefix + 'UserId';
    var userId = cookieUtils_1.getCookie(userIdCookie);
    if (userId === '') {
        userId = uuidv4();
        cookieUtils_1.setCookie(userIdCookie, userId, 365);
    }
    return userId;
};
exports.getTestValue = function (testName) {
    return abTests[testName] || null;
};
exports.getTestSuites = function () {
    return optimizely_1.experiments;
};
/**
 * Returns the first complete param from website url
 * @constructor
 * @param {string} conversion - name of event for test
 * @param {boolean} fireEventForWeb
 *
 * */
exports.track = function (conversion, fireEventForWeb) {
    if (optimizelyClientInstance != null) {
        // Track conversion event for user
        var userId = exports.getUserId();
        optimizelyClientInstance.track(conversion, userId, exports.getAttributes());
    }
    // tslint:disable-next-line: no-boolean-literal-compare
    if (fireEventForWeb === true && exports.isOptimizelyWebLoaded()) {
        exports.getOptimizelyWindowObj().push({
            type: 'event',
            eventName: conversion,
            tags: {
                revenue: 0,
                value: 0.00
            }
        });
    }
};
var gup = function (nameInput, url) {
    var name = nameInput.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
    // tslint:disable-next-line: prefer-template
    var results = new RegExp('[?&]' + name + '=?([^&#]*)').exec(url || window.location.href);
    return results == null ? null : results[1] || true;
};
exports.getAttributes = function () {
    var isMobile = browserHelper_1.isDeviceMobile();
    var isSDP = browserHelper_1.isCurrentFrameSDP(window);
    var browserUrl = browserHelper_1.getCurrentBrowserUrl(window, document).toLowerCase();
    var dsEnv = gup('dsenv', browserUrl);
    var envValue = '';
    switch (dsEnv) {
        case 'local-ssl':
            envValue = 'local';
            break;
        case 'dev':
        case 'qa':
            envValue = dsEnv;
            break;
        default:
            envValue = 'prod';
    }
    var sponsorValue = gup('sponsor', browserUrl);
    if (!sponsorValue) {
        if (browserUrl.search(/www\.autotrader\.com/i) !== -1) {
            sponsorValue = 'atc';
        }
        else if (browserUrl.search(/www\.kbb\.com/i) !== -1) {
            sponsorValue = 'kbb';
        }
        else {
            sponsorValue = 'other';
        }
    }
    var testValue = browserUrl.search(/fullStackTest/i) !== -1 ? true : false;
    var dnaAccountId = exports.getCurrentDealer().dnaAccountId;
    var attributes = {
        Env: envValue,
        Test: testValue,
        Sponsor: sponsorValue,
        DnaAccountId: dnaAccountId,
        Device: isMobile ? 'Mobile' : 'Desktop',
        OS: isMobile ? browserHelper_1.getMobileDeviceOs() : '',
        Frame: isSDP ? 'SDP' : 'VDP'
    };
    return attributes;
};
// WEB SDK is loaded based enableOptimizelyDealStarter & enableOptimizelyShopperPlatform toggles
exports.isOptimizelyWebLoaded = function () {
    var optimizely = exports.getOptimizelyWindowObj();
    return optimizely.initialized || false;
};
exports.activateTests = function (userId) {
    var adobeAnalyticsTrackingObj = exports.getAdobeAnalyticsTrackingObj();
    try {
        exports.optimizelyLog('Start Activation');
        exports.initAdobeAnalytics(adobeAnalyticsTrackingObj);
        exports.retrieveFullStackSuite(userId, adobeAnalyticsTrackingObj);
        exports.optimizelyLog('Finished Activation');
        /* Commenting out for testing
            if (isOptimizelyWebLoaded()) {
             activateWebSuite(adobeAnalyticsTrackingObj);
            }
        */
    }
    catch (error) {
        console.error(error);
    }
    finally {
        exports.sendAnalytics(adobeAnalyticsTrackingObj);
        // tslint:disable-next-line: prefer-template
        exports.optimizelyLog('sendAnalytics : ' + adobeAnalyticsTrackingObj);
    }
};
exports.sendAnalytics = function (adobeAnalyticsTrackingObj) {
    if (adobeAnalyticsTrackingObj && (adobeAnalyticsTrackingObj[listVar] || []).length > 0) {
        var analyticsSegment = adobeAnalyticsTrackingObj[listVar].join();
        adobeAnalyticsTrackingObj[listVar] = analyticsSegment;
        adobeAnalyticsTrackingObj.tl(true, 'o', 'OptimizelyLayerDecision');
    }
};
exports.initAdobeAnalytics = function (adobeAnalyticsTrackingObj) {
    // try reseting if adobe loaded slower than utils
    var adobeAnalyticsTracking = adobeAnalyticsTrackingObj;
    if (!adobeAnalyticsTracking) {
        adobeAnalyticsTracking = exports.getAdobeAnalyticsTrackingObj();
    }
    if (adobeAnalyticsTracking) {
        adobeAnalyticsTracking[listVar] = adobeAnalyticsTracking[listVar] || [];
        adobeAnalyticsTracking.linkTrackVars ? adobeAnalyticsTracking.linkTrackVars += ',list3' : 'list3';
    }
    // tslint:disable-next-line: prefer-template
    exports.optimizelyLog('initAdobeAnalytics : ' + adobeAnalyticsTracking.linkTrackVars);
    return true;
};
/**
 * Only Activate the Experiments that are not onDemand, in order to Activate the onDemand test please:
 * Call activateExperiment externally with the test. For more information please go to link below.
 * https://docs.developers.optimizely.com/full-stack/docs/implement-impressions#section-get-variations-without-sending-an-impression
 */
exports.retrieveFullStackSuite = function (userId, adobeAnalyticsTrackingObj, experimentTests, optimizelyClient) {
    if (experimentTests === void 0) { experimentTests = optimizely_1.experiments; }
    if (optimizelyClient === void 0) { optimizelyClient = optimizelyClientInstance; }
    experimentTests.forEach(function (_a) {
        var testName = _a.testName, experimentId = _a.experimentId, testVariations = _a.testVariations, activateOnDemand = _a.activateOnDemand;
        // Only bucket user and send impression to Optimizely (activate call) if user hasn't been bucketed
        var hasBuckettedForTestCookie = cookiePrefix + testName;
        var bucketedVariation = activateOnDemand ?
            optimizelyClient.getVariation(testName, userId, exports.getAttributes()) :
            optimizelyClient.activate(testName, userId, exports.getAttributes());
        abTests[testName] = bucketedVariation;
        // If the test is live and able to be activated, set the cookie so we don't activate the user again
        if (abTests[testName] !== '' && abTests[testName] !== null) {
            var variationKey = exports.generateVariationKey(experimentId, testVariations, bucketedVariation);
            if (adobeAnalyticsTrackingObj && whitelist.indexOf(experimentId) > -1) {
                adobeAnalyticsTrackingObj[listVar].push(variationKey);
                // tslint:disable-next-line: prefer-template
                exports.optimizelyLog('Added Variation  : ' + variationKey);
            }
            // tslint:disable-next-line: prefer-template
            exports.optimizelyLog('setCookie : ' + hasBuckettedForTestCookie);
            cookieUtils_1.setCookie(hasBuckettedForTestCookie, 'true', 365);
        }
    });
    // tslint:disable-next-line: prefer-template
    exports.optimizelyLog('retrieveFullStackSuite Finished : ' + adobeAnalyticsTrackingObj[listVar]);
};
/**
 * Call when need to count a visitor as having been exposed to some variant that was rendered earlier based on a Get Variation call
 * Call this function with many experiment in a test. (Usually each test has more than one experiment)
 * @param  {string[]} expNames the name of experiments
 * @return no need to know the variation value since the user is already bucketed
 */
exports.activateExperiments = function (expNames, optimizelyClient) {
    if (optimizelyClient === void 0) { optimizelyClient = optimizelyClientInstance; }
    if (!optimizelyClient) {
        return;
    }
    expNames.forEach(function (expName) {
        var bucketedVariation = optimizelyClient.activate(expName, exports.getUserId(), exports.getAttributes());
        exports.optimizelyLog(expName + " got activated. Currently bucketed to " + bucketedVariation + ".");
    });
};
exports.activateWebSuite = function (adobeAnalyticsTrackingObj) {
    var state = exports.getOptimizelyWindowObj().get('state');
    var activeCampaigns = [];
    if (state) {
        activeCampaigns = state.getCampaignStates({ isActive: true });
    }
    Object.keys(activeCampaigns).forEach(function (key) {
        var _thisCampaign = activeCampaigns[key];
        var campaignId = _thisCampaign.id;
        var experimentId = _thisCampaign.experiment.id;
        var variationId = _thisCampaign.variation.id;
        var variationKey = exports.generateVariationWebKey(campaignId, experimentId, variationId);
        if (adobeAnalyticsTrackingObj) {
            adobeAnalyticsTrackingObj[listVar].push(variationKey);
        }
    });
    // tslint:disable-next-line: prefer-template
    exports.optimizelyLog('activateWebSuite Finished : ' + adobeAnalyticsTrackingObj[listVar]);
};
exports.generateVariationWebKey = function (campaignId, experimentId, bucketedVariationId) {
    return "(" + campaignId + "):(" + experimentId + "):(" + bucketedVariationId + ")";
};
exports.generateVariationKey = function (experimentId, testVariations, bucketedVariation) {
    var variationObj = testVariations.find(function (variation) { return variation.name === bucketedVariation; });
    /* Added for testing purposes */
    // tslint:disable-next-line: prefer-template
    var userIdCookie = cookiePrefix + 'UserId';
    var userId = cookieUtils_1.getCookie(userIdCookie);
    /* Testing purposes */
    return "(" + experimentId + "):(" + variationObj['id'] + "):(" + userId + ")";
};
exports.setOverrides = function () {
    optimizely_1.experiments.forEach(function (_a) {
        var testVariations = _a.testVariations, testName = _a.testName;
        var isValidOverride = exports.isParamOverrideValid(testVariations, testName);
        if (isValidOverride) {
            abTests[testName] = isValidOverride;
        }
    });
};
exports.getOverrideFromUrlByKey = function (key, browserUrl) {
    var overrideRegEx = new RegExp(key + "=[^&]+");
    var overrideRegExResult = overrideRegEx.exec(browserUrl);
    if (overrideRegExResult) {
        return overrideRegExResult[0].split('=')[1];
    }
    return null;
};
exports.getTestOverrideParams = function (depWindow, depDocument) {
    var params = '';
    optimizely_1.experiments.forEach(function (_a) {
        var testVariations = _a.testVariations, testName = _a.testName;
        var isValidOverride = exports.isParamOverrideValid(testVariations, testName, depWindow, depDocument);
        if (isValidOverride) {
            params += testName + "=" + isValidOverride['name'] + "&";
        }
    });
    if (exports.shouldAppendFullStackOverrideParam(depWindow, depDocument)) {
        params += "fullStackTest&";
    }
    return params;
};
exports.shouldAppendFullStackOverrideParam = function (depWindow, depDocument) {
    var windowObject = depWindow || window;
    var documentObject = depDocument || document;
    var browserUrl = browserHelper_1.getCurrentBrowserUrl(windowObject, documentObject);
    return browserUrl.search(/fullStackTest/i) !== -1 ? true : false;
};
exports.isParamOverrideValid = function (testVariations, testName, depWindow, depDocument) {
    var windowObject = depWindow || window;
    var documentObject = depDocument || document;
    var browserUrl = browserHelper_1.getCurrentBrowserUrl(windowObject, documentObject);
    var testOverride = exports.getOverrideFromUrlByKey(testName, browserUrl);
    var isValidOverride = testVariations.find(function (test) { return test.name === testOverride; });
    return isValidOverride;
};
